angular.module('tgaAdmin').config([
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider',
  function ($stateProvider, $urlRouterProvider, $locationProvider) {
    // AngularUI Router uses the concept of states
    // Learn more here: https://github.com/angular-ui/ui-router
    // Set up the various states which the app can be in.
    // Each state's controller can be found in controllers.js
    $locationProvider.html5Mode(true);

    // resolve functions
    const game = ($stateParams, gameService) => gameService.getGame($stateParams.game_id).catch(angular.noop);
    const languages = (languageService) => languageService.getLanguages().catch(angular.noop);
    const permissions = (domainService) => domainService.getPermissions().catch(angular.noop);
    const preventAfterExpired = (domainService, modalService, $timeout, $state) =>
      domainService
        .getSubscription()
        .then((subscription) => {
          if (subscription.is_expired) {
            $timeout(() => {
              modalService
                .showModal({
                  title: 'Subscription Expired',
                  message: 'Upgrade your account to access this section.',
                  closeButton: false,
                  actionButton: 'OK',
                })
                .then(() => {
                  $state.go('v1.account', {
                    tab: 'subscriptions',
                  });
                });
            }, 0);
          }
        })
        .catch(angular.noop);
    const preventAfterGracePeriod = (domainService, modalService, $timeout, $state) =>
      domainService
        .getSubscription()
        .then((subscription) => {
          if (subscription.past_exp) {
            $timeout(() => {
              modalService
                .showModal({
                  title: 'Subscription Expired',
                  message: 'Upgrade your account to access this section.',
                  closeButton: false,
                  actionButton: 'OK',
                })
                .then(() => {
                  $state.go('v1.account', {
                    tab: 'subscriptions',
                  });
                });
            }, 0);
          }
        })
        .catch(angular.noop);

    $stateProvider
      .state('v1', {
        abstract: true,
        url: '/v1',
        template: '<ui-view/>',
      })
      .state('v1.login', {
        url: '/login',
        templateUrl: 'templates/views/login.html',
        data: {
          title: 'Login',
        },
      })
      .state('v1.login-two-factor', {
        url: '/login-two-factor',
        controller: 'LoginTwoFactorController',
        templateUrl: 'templates/views/login-two-factor.html',
        data: {
          title: 'Login',
          back: 'v1.login',
        },
      })
      .state('v1.login-common', {
        url: '/login2',
        controller: 'LoginCommonController',
        templateUrl: 'templates/views/login-common.html',
        data: {
          title: 'Login',
        },
      })
      .state('v1.embed', {
        url: '/embed?api_key?hide_menu',
        templateUrl: 'templates/views/embed.html',
        data: {
          title: 'Checking',
        },
      })
      .state('v1.register', {
        url: '/register?plan',
        templateUrl: 'templates/views/register.html',
        data: {
          title: 'Register',
        },
      })
      .state('v1.forgot', {
        url: '/forgot',
        templateUrl: 'templates/views/forgot.html',
        data: {
          title: 'Forgot Password',
        },
      })
      .state('v1.reset', {
        url: '/reset/:token',
        templateUrl: 'templates/views/reset.html',
        data: {
          title: 'Reset Password',
        },
      })
      .state('v1.connect', {
        url: '/connect/:token',
        templateUrl: 'templates/views/connect.html',
        data: {
          title: 'Connect Account',
        },
      })
      .state('v1.analytics', {
        url: '/analytics/{game_id:[0-9]+}',
        templateUrl: 'templates/views/analytics.html',
        data: {
          title: 'Analytics',
          nav: true,
          subnav: true,
          back: 'v1.games',
        },
        resolve: {
          permissions,
          game,
        },
      })
      .state('v1.leaderboard', {
        url: '/leaderboard/{game_id:[0-9]+}',
        templateUrl: 'templates/views/leaderboard.html',
        data: {
          title: 'Leaderboard',
          nav: true,
          subnav: true,
          back: 'v1.games',
        },
        resolve: {
          permissions,
          game,
        },
      })
      .state('v1.account', {
        url: '/account',
        templateUrl: 'templates/views/account.html',
        data: {
          title: 'Account',
          nav: true,
        },
        params: {
          tab: null,
        },
        resolve: {
          permissions,
        },
      })
      .state('v1.instructor', {
        abstract: true,
        url: '/instructor/{game_id:[0-9]+}',
        template: '<ui-view/>',
        data: {
          nav: true,
        },
        resolve: {
          game,
        },
      })
      .state('v1.instructor.sessions', {
        url: '/sessions',
        templateUrl: 'templates/views/instructor-sessions.html',
        controller: 'InstructorSessionsController',
        data: {
          title: 'Instructor',
          nav: true,
          subnav: true,
        },
      })
      .state('v1.instructor.analytics', {
        url: '/sessions/{session_group_id:[0-9]+}',
        templateUrl: 'templates/views/instructor-analytics.html',
        controller: 'InstructorAnalyticsController',
        data: {
          title: 'Instructor',
          nav: true,
          subnav: true,
          back: 'v1.instructor.sessions',
        },
      })
      .state('v1.instructor.game', {
        url: '/game?slug',
        templateUrl: 'templates/views/instructor-game.html',
        controller: 'InstructorGameController',
        data: {
          title: 'Instructor',
          nav: true,
          subnav: true,
          back: 'v1.instructor.sessions',
        },
      })
      .state('v1.instructorList', {
        url: '/instructor-games',
        templateUrl: 'templates/views/instructor.html',
        data: {
          title: 'Instructor',
          nav: true,
        },
      })
      .state('v1.addGame', {
        url: '/game/add/:type',
        templateUrl: 'templates/views/game.html',
        controller: 'GameController',
        data: {
          title: 'New Game',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.games',
        },
        params: {
          viewmodel: null,
          data: null,
        },
        resolve: {
          permissions,
          languages,
        },
      })
      .state('v1.editGame', {
        url: '/game/{game_id:[0-9]+}?api_key?hide_menu',
        templateUrl: 'templates/views/game.html',
        controller: 'GameController',
        data: {
          title: 'Edit Game',
          nav: true,
          subnav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
        resolve: {
          permissions,
          languages,
          game,
        },
      })
      .state('v1.gameAccess', {
        url: '/permissions/{game_id:[0-9]+}',
        templateUrl: 'templates/views/game-access.html',
        controller: 'GameAccessController',
        data: {
          title: 'Permissions',
          nav: true,
          subnav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
        resolve: {
          permissions,
          languages,
          game,
        },
      })
      .state('v1.games', {
        url: '/games',
        templateUrl: 'templates/views/games.html',
        data: {
          title: 'Games',
          nav: true,
        },
        params: {
          lastStep: null,
        },
        resolve: {
          permissions,
        },
      })
      .state('v1.archive', {
        url: '/games/archive',
        templateUrl: 'templates/views/archive.html',
        data: {
          title: 'Archive',
          nav: true,
          back: 'v1.games',
        },
        resolve: {
          permissions,
        },
      })
      .state('v1.hubArchive', {
        url: '/hubs/archive',
        templateUrl: 'templates/views/hub-archive.html',
        data: {
          title: 'Archive',
          nav: true,
          back: 'v1.hubs',
        },
        resolve: {
          permissions,
        },
      })
      .state('v1.hubs', {
        url: '/hubs',
        templateUrl: 'templates/views/hub-list.html',
        data: {
          title: 'Arcades™',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin', 'viewer_admin'],
        },
      })
      .state('v1.addHub', {
        url: '/hub/add',
        templateUrl: 'templates/partials/hub/settings.html',
        data: {
          title: 'New Arcade™',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.hubs',
        },
        resolve: {
          preventAfterExpired,
        },
      })
      // inside hub
      .state('v1.hub', {
        abstract: true,
        url: '/hub/{hub_id:[0-9]+}',
        template: '<ui-view/>',
        data: {
          title: 'Arcades™',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin', 'viewer_admin'],
          subnav: true,
          is_hub: true,
        },
        resolve: {
          preventAfterGracePeriod,
        },
      })
      .state('v1.hub.dashboard', {
        url: '/dashboard',
        templateUrl: 'templates/partials/hub/dashboard.html',
        data: {
          title: 'Dashboard',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.analytics', {
        url: '/analytics',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin', 'viewer_admin'],
        },
        resolve: {
          permissions,
        },
        views: {
          '': {
            templateUrl: 'templates/partials/hub/analytics.html',
          },
          'activities-tab@v1.hub.analytics': {
            templateUrl: 'templates/partials/hub/analytics/activities.html',
          },
        },
      })
      .state('v1.hub.analytics.activities', {
        abstract: true,
        url: '/activities',
        template: '<ui-view/>',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.analytics.activities.activity', {
        url: '/{game_id:[0-9]+}',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
        params: {
          range: null,
          dateRange: {},
        },
        views: {
          'activities-tab@v1.hub.analytics': {
            templateUrl: 'templates/partials/hub/analytics/activity.html',
          },
        },
      })
      .state('v1.hub.activities', {
        url: '/activities',
        templateUrl: 'templates/partials/hub/activities.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.journeys', {
        url: '/journeys',
        templateUrl: 'templates/partials/hub/journeys.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.addJourney', {
        url: '/journey/add',
        templateUrl: 'templates/partials/hub/journeys.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.hub.journeys',
        },
      })
      .state('v1.hub.editJourney', {
        url: '/journey/{course_group_id:[0-9]+}',
        templateUrl: 'templates/partials/hub/journeys.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.hub.journeys',
        },
      })
      .state('v1.hub.missions', {
        url: '/missions',
        templateUrl: 'templates/partials/hub/missions.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.addMission', {
        url: '/mission/add',
        templateUrl: 'templates/partials/hub/missions.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.hub.missions',
        },
      })
      .state('v1.hub.editMission', {
        url: '/mission/{course_group_id:[0-9]+}',
        templateUrl: 'templates/partials/hub/missions.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.hub.missions',
        },
      })
      .state('v1.hub.prizes', {
        url: '/prizes',
        templateUrl: 'templates/partials/hub/prizes.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.theme', {
        url: '/theme',
        templateUrl: 'templates/partials/hub/theme.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.achievements', {
        url: '/achievements',
        templateUrl: 'templates/partials/hub/achievements.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.faqs', {
        url: '/faq',
        templateUrl: 'templates/partials/hub/faqs.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.edit', {
        url: '/edit',
        templateUrl: 'templates/partials/hub/settings.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.registration', {
        url: '/registration',
        templateUrl: 'templates/partials/hub/registration.html',
        data: {
          title: 'Arcades™',
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.playerLists', {
        url: '/player-lists',
        templateUrl: 'templates/partials/hub/player-lists.html',
        data: {
          title: 'Player Lists',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.hub.addPlayerList', {
        url: '/player-lists/add',
        templateUrl: 'templates/partials/hub/player-list.html',
        data: {
          title: 'Add a Player List',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.hub.playerLists',
        },
      })
      .state('v1.hub.editPlayerList', {
        url: '/player-lists/{id:[0-9]+}',
        templateUrl: 'templates/partials/hub/player-list.html',
        data: {
          title: 'Edit Player List',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.hub.playerLists',
        },
      })
      .state('v1.courseList', {
        url: '/course',
        templateUrl: 'templates/views/course-list.html',
        data: {
          title: 'Courses',
          nav: true,
          allowedUsers: ['super_admin'],
        },
      })
      .state('v1.addCourse', {
        url: '/course/add',
        templateUrl: 'templates/views/course.html',
        data: {
          title: 'Add a Course ',
          nav: true,
          allowedUsers: ['super_admin'],
          back: 'v1.courseList',
        },
      })
      .state('v1.editCourse', {
        url: '/course/edit/{id:[0-9]+}',
        templateUrl: 'templates/views/course.html',
        data: {
          title: 'Edit Course',
          nav: true,
          allowedUsers: ['super_admin'],
          back: 'v1.courseList',
        },
      })
      .state('v1.playerLists', {
        url: '/player-lists',
        templateUrl: 'templates/views/player-lists.html',
        data: {
          title: 'Player Lists',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.addPlayerList', {
        url: '/player-lists/add',
        templateUrl: 'templates/views/player-list.html',
        data: {
          title: 'Add a Player List',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.playerLists',
        },
      })
      .state('v1.editPlayerList', {
        url: '/player-lists/{id:[0-9]+}',
        templateUrl: 'templates/views/player-list.html',
        data: {
          title: 'Edit Player List',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.playerLists',
        },
      })
      .state('v1.questionLists', {
        url: '/question-list',
        templateUrl: 'templates/views/question-lists.html',
        data: {
          title: 'Question Lists',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.addQuestionList', {
        url: '/question-list/add',
        templateUrl: 'templates/views/question-list.html',
        controller: 'QuestionListController',
        data: {
          title: 'Add Question List',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.questionLists',
        },
        resolve: {
          languages,
        },
      })
      .state('v1.editQuestionList', {
        url: '/question-list/{question_list_id:[0-9]+}',
        templateUrl: 'templates/views/question-list.html',
        controller: 'QuestionListController',
        data: {
          title: 'Edit Question List',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.questionLists',
        },
        resolve: {
          languages,
        },
      })
      .state('v1.customFields', {
        url: '/custom-field',
        templateUrl: 'templates/views/custom-fields.html',
        data: {
          title: 'Custom Fields',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.addCustomField', {
        url: '/custom-field/add',
        templateUrl: 'templates/views/custom-field.html',
        controller: 'CustomFieldController',
        data: {
          title: 'Add Custom Field',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.customFields',
        },
        resolve: {
          languages,
        },
      })
      .state('v1.editCustomField', {
        url: '/custom-field/{custom_field_id:[0-9]+}',
        templateUrl: 'templates/views/custom-field.html',
        controller: 'CustomFieldController',
        data: {
          title: 'Edit Custom Field',
          nav: true,
          allowedUsers: ['editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
          back: 'v1.customFields',
        },
        resolve: {
          languages,
        },
      })
      .state('v1.division', {
        url: '/division',
        templateUrl: 'templates/views/divisions.html',
        data: {
          title: 'Division',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.addDivision', {
        url: '/division/add',
        templateUrl: 'templates/views/division.html',
        controller: 'DivisionController',
        data: {
          title: 'Add Division',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
          back: 'v1.division',
        },
        resolve: {
          languages,
        },
      })
      .state('v1.editDivision', {
        url: '/division/{division_id:[0-9]+}',
        templateUrl: 'templates/views/division.html',
        controller: 'DivisionController',
        data: {
          title: 'Edit Division',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
          back: 'v1.division',
        },
        resolve: {
          languages,
        },
      })
      .state('v1.ssoProviders', {
        url: '/sso',
        templateUrl: 'templates/views/sso-providers.html',
        data: {
          title: 'Single Sign-On',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'support_admin'],
        },
      })
      .state('v1.addSSOProvider', {
        url: '/sso/add',
        templateUrl: 'templates/views/sso-provider.html',
        data: {
          title: 'Add SSO Provider',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'support_admin'],
          back: 'v1.ssoProviders',
        },
      })
      .state('v1.editSSOProvider', {
        url: '/sso/{id:[0-9]+}',
        templateUrl: 'templates/views/sso-provider.html',
        data: {
          title: 'Edit SSO Provider',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'support_admin'],
          back: 'v1.ssoProviders',
        },
      })
      .state('v1.users', {
        url: '/users',
        templateUrl: 'templates/views/users.html',
        data: {
          title: 'Users',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.addUser', {
        url: '/users/add',
        templateUrl: 'templates/views/user.html',
        data: {
          title: 'Add a User',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'support_admin'],
          back: 'v1.users',
        },
      })
      .state('v1.editUser', {
        url: '/users/{id:[0-9]+}',
        templateUrl: 'templates/views/user.html',
        data: {
          title: 'Edit User',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'support_admin'],
          back: 'v1.users',
        },
      })
      .state('v1.players', {
        url: '/players',
        templateUrl: 'templates/views/players.html',
        data: {
          title: 'Players',
          nav: true,
          allowedUsers: ['super_admin'],
        },
      })
      .state('v1.addPlayer', {
        url: '/players/add',
        templateUrl: 'templates/views/player-add.html',
        data: {
          title: 'Add a Player',
          nav: true,
          allowedUsers: ['super_admin'],
          back: 'v1.players',
        },
      })
      .state('v1.settings', {
        url: '/settings',
        templateUrl: 'templates/views/settings.html',
        data: {
          title: 'Settings',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.help', {
        url: '/help',
        templateUrl: 'templates/views/help.html',
        data: {
          title: 'Help',
          nav: true,
          allowedUsers: ['user', 'editor', 'admin', 'super_admin', 'creator_admin', 'support_admin', 'sales_admin'],
        },
      })
      .state('v1.reports', {
        url: '/reports',
        templateUrl: 'templates/views/reports.html',
        data: {
          title: 'Reports',
          nav: true,
          allowedUsers: ['super_admin', 'support_admin'],
        },
      })
      .state('v1.domains', {
        url: '/domains',
        templateUrl: 'templates/views/domains.html',
        data: {
          title: 'Domains',
          nav: true,
          allowedUsers: ['super_admin'],
        },
      })
      .state('v1.addDomain', {
        url: '/domains/add',
        templateUrl: 'templates/views/domain.html',
        data: {
          title: 'Add a Domain',
          nav: true,
          allowedUsers: ['super_admin'],
          back: 'v1.domains',
        },
      })
      .state('v1.editDomain', {
        url: '/domains/{domain_id:[0-9]+}',
        templateUrl: 'templates/views/domain.html',
        data: {
          title: 'Domains',
          nav: true,
          allowedUsers: ['super_admin'],
          back: 'v1.domains',
        },
      })
      .state('v1.events', {
        url: '/events',
        templateUrl: 'templates/views/events.html',
        data: {
          title: 'Event',
          nav: true,
          allowedUsers: ['super_admin'],
        },
      })
      .state('v1.progress', {
        url: '/progress',
        templateUrl: 'templates/views/progress.html',
        data: {
          title: 'Progress',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.activity', {
        url: '/activity',
        templateUrl: 'templates/views/activity.html',
        data: {
          title: 'New Activity',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.editActivity', {
        url: '/activity/{id:[0-9]+}',
        templateUrl: 'templates/views/activity.html',
        data: {
          title: 'Edit Activity',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.coupon', {
        url: '/coupon',
        templateUrl: 'templates/views/coupons.html',
        data: {
          title: 'Activation Codes',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.addCoupon', {
        url: '/coupon/add',
        templateUrl: 'templates/views/coupon.html',
        data: {
          title: 'Add a Activation Code',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.editCoupon', {
        url: '/coupon/{id:[0-9]+}',
        templateUrl: 'templates/views/coupon.html',
        data: {
          title: 'Edit Activation Code',
          nav: true,
          allowedUsers: ['admin', 'super_admin', 'sales_admin', 'support_admin'],
        },
      })
      .state('v1.banners', {
        url: '/banners',
        templateUrl: 'templates/views/banner.html',
        data: {
          title: 'Banners Notifications',
          nav: true,
          allowedUsers: ['super_admin'],
        },
      })
      .state('v1.addBanner', {
        url: '/banners/add',
        templateUrl: 'templates/views/banner_create_or_update.html',
        data: {
          title: 'Add a Banner Notification',
          nav: true,
          allowedUsers: ['super_admin'],
        },
      })
      .state('v1.editBanner', {
        url: '/banners/{banner_id:[0-9]+}',
        templateUrl: 'templates/views/banner_create_or_update.html',
        data: {
          title: 'Edit Banner Notification',
          nav: true,
          allowedUsers: ['super_admin'],
        },
      });

    // Consider any URLs containing `/v2/` handled (to defeat `otherwise` below).
    $urlRouterProvider.when(/\/v2\//i, () => true);

    // if none of the above states are matched, use this as the fallback
    $urlRouterProvider.otherwise('/v1/login');
  },
]);
